import React from 'react';

const CallContentVertical = ({ heading, headingColor, btnText, btnLink, btnClasses }) => {
    return (
        <div className="call-content vertical-call-to-action text-center">
            <h3 className="heading" style={{ color: headingColor, fontFamily: "Montserrat" }}>{heading}</h3>
            <div className="spacing" />
            <div className="call-btn text-center">
                <a className={`brook-btn ${btnClasses}`}
                    href={btnLink}
                    target="__blank" 
                    rel="noreferrer"
                >
                    {btnText}
                </a>
            </div>
        </div>
    );
};

export default CallContentVertical;